// extracted by mini-css-extract-plugin
module.exports = {"img":"img-3uJXY","actions":"actions-2FJq4"};